import Vue from 'vue';
import Router from 'vue-router';
import _ from 'lodash';

export interface HITLParams extends Record<string, string | undefined> {
  readonly contactId?: string;
  readonly sessionId?: string;
  readonly filterId?: string;
  readonly layout?: string;
}

export class AppRouter {
  public static QUERY_PARAMS = {
    CONTACT_ID: 'contactId',
    SESSION_ID: 'sessionId',
    FILTER_ID: 'filterId',
    WORKSPACE: 'workspace',
    LAYOUT: 'layout',
  };
  public static $router: Router;

  public static bind(vm: Vue) {
    this.$router = vm.$router;
  }

  public static resolve(options: { query?: HITLParams; } = {}) {
    return this.$router.resolve(options);
  }

  public static getQuery() {
    return this.$router.currentRoute.query as HITLParams;
  }

  /**
   * Duplicate navigation can cause error, first check if paths are identical.
   * Usually, when switching sessions, we replace history rather then push.
   */
  public static async setQuery(options: {
    query?: HITLParams;
    replace?: boolean;
  }) {
    const { query = {}, replace } = options;
    const path = this.$router.resolve({ query }).href;

    if (this.$router.currentRoute.fullPath === path) {
      return this.$router.currentRoute;
    }

    const compact = _.pickBy(query, value => !!value);
    return replace
      ? this.$router.replace({ query: compact })
      : this.$router.push({ query: compact });
  }

  /** Add or replace query params with given dictionary */
  public static appendQuery(options: {
    query?: HITLParams;
    replace?: boolean;
  }) {
    const query = { ...this.getQuery(), ...options.query } as HITLParams;
    const compact = _.pickBy(query, value => !!value);
    return this.setQuery({ query: compact, replace: options.replace });
  }
}
